import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const ResellerList = (teamData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RESELLER_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/agent/list`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_RESELLER_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RESELLER_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_RESELLER_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const VrTransactionList = (teamData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_VR_TRANSACTION_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/vr-payment-history/vr-payment-history-list`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_VR_TRANSACTION_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_VR_TRANSACTION_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_VR_TRANSACTION_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const ResellerView = (teamData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RESELLER_LIST_VIEW_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/agent/profile/${teamData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RESELLER_LIST_VIEW_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RESELLER_LIST_VIEW_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_RESELLER_LIST_VIEW_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};